import { combineUint8Arrays, enumToByteArray, format, numberToByteArray, stringToByteArray } from '../utils/utils';
export function getVaultEntryBytesToBeSigned(entry) {
    return getBytesToBeSigned(entry.userId, entry.addedAt, entry.requestorPublicKey, entry.lastSeenId, entry.verifiedById, entry.operation, entry.keyType, entry.version);
}
export function getBytesToBeSigned(userId, addedAt, publicKey, lastSeenId, verifiedById, operation, keyType, version) {
    const userIdBytes = stringToByteArray(userId);
    const formattedDate = format(addedAt);
    const addedAtBytes = stringToByteArray(formattedDate);
    const lastSeenIdBytes = numberToByteArray(lastSeenId);
    const verifiedByIdBytes = numberToByteArray(verifiedById);
    const operationBytes = enumToByteArray(operation);
    const keyTypeBytes = enumToByteArray(keyType);
    const versionBytes = numberToByteArray(version);
    return combineUint8Arrays(userIdBytes, addedAtBytes, publicKey, lastSeenIdBytes, verifiedByIdBytes, operationBytes, keyTypeBytes, versionBytes);
}
